import { withRouter } from 'react-router'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { compose, withProps, withStateHandlers, withHandlers } from 'recompose'

import withNotifications from 'components/shared/notifications'
import withOrgTeamAvailabilities from 'app/modules/teams/hoc/withOrgTeamAvailabilities'

import { patchOrgTeam, updateAvailabilityForTeam } from 'app/modules/teams/actions'
import {
  updateAvailabilityForTeamPending,
  updateAvailabilityForTeamSucceeded,
  updateAvailabilityForTeamFailed,
} from 'app/modules/teams/selectors'
import { HOURS_EDIT_MODES, HOURS_AVAILABILITY_MODES } from 'app/modules/teams/constants'

import TeamHoursManager from './component'

const mapStateToProps = state => {
  return {
    updatePending: updateAvailabilityForTeamPending(state),
    updateCompleted: updateAvailabilityForTeamSucceeded(state) || updateAvailabilityForTeamFailed(state),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      updateAvailabilityForTeam,
      patchOrgTeam,
    },
    dispatch
  ),
})

export default compose(
  withRouter,
  withNotifications,
  withOrgTeamAvailabilities,
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({ team }) => ({
    createNewAvailability: !team.teamAvailabilityId,
  })),
  withStateHandlers(
    ({ team }) => ({
      editMode: HOURS_EDIT_MODES.REVIEW,
      selectedHoursMode: team.teamAvailabilityMode,
      disableSave: false,
      isSaving: false,
      availabilitySettings: undefined,
      errorMessages: [],
    }),
    {
      setEditMode: () => editMode => ({ editMode }),
      setAvailabilityAlwaysOnlineMode: () => () => ({
        selectedHoursMode: HOURS_AVAILABILITY_MODES.ALWAYS_ONLINE,
      }),
      setAvailabilityScheduledHoursMode: () => () => ({
        selectedHoursMode: HOURS_AVAILABILITY_MODES.CUSTOM_HOURS,
      }),
      setAvailabilityAlwaysOfflineMode: () => () => ({
        selectedHoursMode: HOURS_AVAILABILITY_MODES.ALWAYS_OFFLINE,
      }),
      setSaveDisabled: () => disableSave => ({ disableSave }),
      setIsSaving: () => isSaving => ({ isSaving }),
      setAvailabilitySettings: () => availabilitySettings => ({
        availabilitySettings,
      }),
      setErrors: () => errorMessages => ({
        errorMessages,
      }),
      setHoursMode: () => hoursMode => ({
        selectedHoursMode: hoursMode,
      }),
    }
  ),
  withHandlers({
    handleEditHoursClick: ({ setEditMode }) => () => {
      setEditMode(HOURS_EDIT_MODES.EDIT)
    },
    handleHoursSettingsChange: ({ setSaveDisabled, setErrors, setAvailabilitySettings }) => settings => {
      const openHours = settings.get('openHours')
      if (
        !openHours.every(
          slot =>
            slot.startTime.hour < slot.endTime.hour ||
            (slot.startTime.hour === slot.endTime.hour && slot.startTime.minutes < slot.endTime.minutes)
        )
      ) {
        setErrors(["Please make sure each slot's start time is before the end time"])
        setSaveDisabled(true)
      } else {
        setErrors([])
        setSaveDisabled(false)
      }
      setAvailabilitySettings(settings)
    },
    handleSaveClick: ({
      team,
      actions,
      availabilitySettings,
      notifications,
      setIsSaving,
      setEditMode,
      selectedHoursMode,
    }) => () => {
      setIsSaving(true)
      if (selectedHoursMode === HOURS_AVAILABILITY_MODES.CUSTOM_HOURS) {
        actions.updateAvailabilityForTeam({ teamId: team.id, teamAvailabilitySettings: availabilitySettings })
      }
      actions.patchOrgTeam({
        teamId: team.id,
        properties: [{ property: 'teamAvailabilityMode', operation: 'set', value: selectedHoursMode }],
      })
      setTimeout(() => {
        notifications.success(`Hours for ${team.name} have been updated.`)
        setEditMode(HOURS_EDIT_MODES.REVIEW)
        setIsSaving(false)
      }, 500)
    },
    handleCancelClick: ({ setEditMode, setHoursMode, team }) => () => {
      setHoursMode(team.teamAvailabilityMode)
      setEditMode(HOURS_EDIT_MODES.REVIEW)
    },
  })
)(TeamHoursManager)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Teams/TeamHoursManager/index.js